import widgetContentItemsState from '../general/widget-content-items/state';

export default {
	...widgetContentItemsState,
	sidebar: {
		projectAvailable: false,
		projectId: null,
		projectName: '',
		accountName: null,
		path: null,
		user: {},
		isSuperAdmin: false,
		userProjects: [],
		currentUserAccount: {},
		userProjectsByBookmarkId: [],
		menuColor: '',
		width: 0,
		isFetch: true,
		windowWidth: 0,
	}
}
